import { section } from "@/neon";
import { animateSectionIntroduction } from "@/lib/animation";

section("rich-text", {
  onLoad() {
    this.animateSectionIntroduction = animateSectionIntroduction(
      this.container
    );
  },
  onUnload() {
    this.animateSectionIntroduction?.destroy();
  },
});
